<template>
  <div>
    <div class="margin-bottom-20 p-relative">
      <Button type="primary" shape="circle" icon="md-arrow-back" @click="to_back_list"></Button>
      <br />
      <br />
      <div class="lease-page">
        <h4>出租方（以下简称“甲方”）： {{ add_params.APartyName }}</h4>
        <h4>开户银行：{{ add_params.APartyBankName }}</h4>
        <h4>账号： {{ add_params.APartyBankNum }}</h4>
        <h4>
          <span>
            承租方（以下简称“乙方”）：
            <Input
              size="small"
              placeholder="请选择承租方"
              v-model="add_params.BPartyName"
              style="width: 230px;"
            />
          </span>
          <span class="right">
            （营业执照或身份证号：
            <Input
              size="small"
              placeholder="请选择营业执照"
              v-model="add_params.BPartyNum"
              style="width: 230px;"
            />）
          </span>
          <Tooltip content="选择合同承租人" class="btn_add" placement="left">
            <Button type="primary" shape="circle" icon="md-person-add" @click="to_openUser"></Button>
          </Tooltip>
        </h4>
        <!--<h4 v-else>承租方（以下简称“乙方”）：<b>{{add_params.BPartyName}}</b><span class="right">（营业执照或身份证号：<b>{{add_params.BPartyNum}}</b>）</span></h4>-->
        <p
          class="clear-both"
        >根据《中华人民共和国合同法》及相关法律、法规之规定，甲乙双方本着“平等自愿、诚实守信”的原则，经友好协商，现就甲方将其房屋租赁给乙方使用的相关事宜达成一致意见，签订本合同，以资双方共同遵守：</p>
        <br />
        <h3 class="text-center">签约说明</h3>
        <h4>
          第一条 租赁标的
          <Tooltip
            content="选择合同对应商铺"
            class="btn_add"
            placement="left"
            v-if="d_edit_type[0]==='add'"
          >
            <Button type="primary" shape="circle" icon="md-add" @click="to_openShop"></Button>
          </Tooltip>
        </h4>
        <article class="padding-l20">
          <p>
            1、租赁标的：位于成都市
            <Input
              size="small"
              v-model="add_params.Address"
              v-if="d_edit_type[0]==='add'"
              style="width: 230px;"
            />
            <b v-else>{{add_params.Address}}</b> 的商业用房。
          </p>
          <p>
            2、租赁物建筑面积：
            <Input size="small" @on-change="changeArea" v-model="add_params.Area" />平方米。
          </p>
        </article>
        <h4>第二条 租赁用途</h4>
        <article class="padding-l20">
          <p>
            乙方承租租赁物的用途及经营范围：
            <Input size="small" v-model="add_params.BusinessScope" style="width: 200px;" />
          </p>
        </article>
        <h4>第三条 租赁期限和优先权</h4>
        <article class="padding-l20">
          <p v-if="d_edit_type[0]==='add'">
            1、双方约定租赁期限为
            <Input size="small" v-model="add_params.TimeUnit" />月，从
            <DatePicker
              size="small"
              type="date"
              format="yyyy-MM-dd"
              :value="add_params.BeginDate"
              placeholder="请选择开始时间"
              @on-change="change_date_start"
              style="width: 180px"
            ></DatePicker>至
            <DatePicker
              size="small"
              type="date"
              :value="add_params.EndDate"
              format="yyyy-MM-dd"
              placeholder="请选择结束时间"
              @on-change="change_date_end"
              style="width: 180px"
            ></DatePicker>止。
          </p>
          <p v-else>
            1、双方约定租赁期限为
            <b>{{add_params.TimeUnit}}</b> 月，从
            <b>{{add_params.BeginDate}}</b> 至
            <b>{{add_params.EndDate}}</b> 。
          </p>
          <p>2、租赁限期届满时，甲方如仍愿继续出租租赁物，在同等条件下，乙方有优先租赁权，但乙方须提前两个月向甲方提出续租要求。乙方未提出续租要求的，租赁期限届满之日起三天内，腾退租赁房屋；乙方未按时腾退租赁房屋的，甲方有权按租赁合同届满时租赁费用的两倍收取乙方实际使用费；逾期超过10天乙方仍未腾退租赁房屋的，甲方除按实际天数收取乙方两倍实际使用费外，视为乙方放弃租赁房屋内物品的所有权，甲方有权自行处理，乙方不得有任何异议。</p>
          <p>3、乙方在租赁期内如改变使用用途或转租，应事前征得甲方书面同意，未经书面同意，乙方不得擅自改变用途或转租、转让、转借。</p>
        </article>
        <h4>第四条 租赁费用和其他费用及给付</h4>
        <article class="padding-l20">
          <p>1、租赁费用</p>
          <div class="padding-l20">
            <p>
              （1）租赁物建筑面积：
              <Input size="small" v-model="add_params.AreaRent" />平方米。
            </p>
            <p>
              （2）租赁费用：
              <Tooltip
                content="添加租赁年度"
                class="btn_add btn_add_shop"
                placement="left"
                v-if="d_edit_type[0]==='add'"
              >
                <Button type="primary" shape="circle" icon="md-add" @click="to_addPriceList"></Button>
              </Tooltip>
            </p>
            <div class="padding-l34">
              <div class="user_info_group">
                <div v-for="(item,index) in add_params.PriceDetailList">
                  <Button
                    v-if="d_edit_type[0]==='add'"
                    class="btn_add btn_del_shop"
                    type="error"
                    shape="circle"
                    icon="md-remove"
                    @click="to_delPriceList(index)"
                  ></Button>
                  <div style="margin-bottom: 15px;">
                    <span style="color: #333">
                      第{{other_modify(index+1)}}个租赁年度（
                      <Input size="small" v-model="item.BeginDate" v-if="d_edit_type[0]==='add'" />
                      <b v-else>{{ item.BeginDate }}</b>
                      -
                      <Input size="small" v-model="item.EndDate" v-if="d_edit_type[0]==='add'" />
                      <b v-else>{{ item.EndDate }}</b>
                      ）
                    </span>
                    <label style="color: #333" v-if="index!=0">
                      ，
                      比上一年度递增
                      <Input
                        size="small"
                        v-model="item.YearPercent"
                        v-if="d_edit_type[0]==='add'"
                        @on-keyup="computedMeterPrice(index)"
                      />
                      <span v-else>{{item.YearPercent}}</span>%
                    </label>
                    <div
                      v-for="(child,cindex) in item.DetailList"
                      :key="cindex"
                      style="margin-top: 5px;"
                    >
                      每月{{ child.Type }}费用&nbsp;¥
                      <Input
                        size="small"
                        v-model="child.MonthPrice"
                        v-if="d_edit_type[0]==='add'"
                        @on-keyup="computedMeterPrice2(index,cindex)"
                      />
                      <b v-else>{{child.MonthPrice}}</b>&nbsp;元，
                      <span>
                        租赁单价&nbsp;¥
                        <Input
                          size="small"
                          v-model="child.MeterPrice"
                          @on-keyup="computedMonthPrice(index,cindex)"
                          v-if="d_edit_type[0]==='add'"
                        />
                        <b v-else>{{child.MeterPrice}}</b>&nbsp;元/
                        <i v-html="child.Type=='车位租金'?'个':'㎡'"></i>/月
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p>（3）租赁费用中所含的管理费与乙方向管理该租赁物所处小区的物业服务公司缴纳的物业管理费不是同一费用。</p>
            <p>
              （4）合同签订后三个工作日内，
              <br />乙方应交付甲方履约保证金：¥
              <Input size="small" v-model="add_params.AgreeDeposit" />
              元（大写人民币：{{ DX(add_params.AgreeDeposit) }}）。
              <br />水电保证金：¥
              <Input size="small" v-model="add_params.WaterDeposit" />
              元（大写人民币：{{ DX(add_params.WaterDeposit) }}），
              <br />以上保证金至本合同履行完毕，乙方凭甲方开具的收款收据甲方于三个工作日内退还乙方（无息），无收款收据甲方有权不予退还保证金。若乙方违约应承担的违约金，甲方有权将乙方所交保证金扣抵，乙方应于甲方扣抵通知之日起5天内补足保证金。
            </p>
            <p>
              （5）租赁费用给付：合同签订后三个工作日内，
              <br />
              乙方应按本合同甲方指定银行账户支付 {{d_payType}} 的租赁费用¥
              <Input size="small" v-model="add_params.FirstQuarterRent" />
              元（大写：{{ DX(add_params.FirstQuarterRent) }}）。以后的租赁费用 {{d_payType}} 给付一次，每次提前15天交纳下 {{d_payType}} 的租赁费用。租赁费用乙方应以转帐形式存入甲方指定银行帐户。甲方并在实际收到租赁费用后三个工作日内给乙方开具发票。
              <br />
              <a>支付方式可修改：</a>
              <Select v-model="d_payType" size="small" style="width:180px">
                <Option
                  v-for="(item,index) in d_payType_list"
                  :value="item.value"
                  :key="index"
                >{{ item.label }}</Option>
              </Select>
            </p>
          </div>
          <p>2、水、电、通讯、光纤等使用费用由乙方自行承担。具体方式为：电费按商业标准执行，水费按商业标准执行（特种用水按相应收费标准执行）。甲方提供给乙方达到商业清水房基本标准，水通、电通的交房条件。</p>
          <p>3、租赁物的内部物业管理由乙方自行负责。</p>
        </article>
      </div>
      <Modal v-model="d_modal_user" title="选择合同承租人" width="800" footer-hide>
        <div class="margin-bottom-10 header-group">
          <Select v-model="user_params.CondList[0].Key" @on-change="change_condList_user">
            <Option
              v-for="(item,index) in d_search_key_user"
              :value="item.value"
              :key="index"
            >{{ item.label }}</Option>
          </Select>
          <Input v-model="user_params.CondList[0].Value" placeholder="请输入搜索内容" />
          <Button type="primary" @click="search_user()">查询</Button>
        </div>
        <Table
          highlight-row
          ref="currentRowTable"
          border
          height="400"
          :columns="d_columns_user"
          :data="d_data_user"
          @on-current-change="change_user"
        ></Table>
      </Modal>
      <Modal v-model="d_modal_shop" :mask-closable="false" title="选择合同对应商铺" width="800px">
        <div class="margin-bottom-10 header-group">
          <Select v-model="shop_params.CondList[0].Key" @on-change="change_condList_shop">
            <Option
              v-for="(item,index) in d_search_key_shop"
              :value="item.value"
              :key="index"
            >{{ item.label }}</Option>
          </Select>
          <Input v-model="shop_params.CondList[0].Value" placeholder="请输入搜索内容" />
          <Button type="primary" @click="search_shop()">查询</Button>
        </div>
        <Table
          ref="selection"
          height="300"
          :columns="d_columns_shop"
          border
          :data="d_data_shop"
          v-if="d_data_shop.length>0"
          @on-selection-change="change_shop"
        ></Table>
        <div style="padding-top:10px;height: 100px;">
          <h4>已选择的商铺：</h4>
          <div v-show="d_curr_shopList.length>0">
            <Tag v-for="(item,index) in d_curr_shopList" :key="index">{{ item.Name }}</Tag>
          </div>
        </div>
        <div slot="footer">
          <Button type="primary" @click="shops_confirm">确认</Button>
        </div>
      </Modal>
    </div>
    <Form ref="formValidate" :model="add_params" :rules="ruleValidate" :label-width="100">
      <Row>
        <Col span="12">
          <FormItem label="合同名称" prop="Name">
            <Input v-model="add_params.Name" placeholder="请输入合同名称"></Input>
          </FormItem>
          <FormItem label="经办人" prop="Agent">
            <Input v-model="add_params.Agent" placeholder="请输入经办人"></Input>
          </FormItem>
          <FormItem label="备注" prop="Notes">
            <Input v-model="add_params.Notes" type="textarea" placeholder="请输入备注" />
          </FormItem>
          <FormItem label="合同附件" prop="photos1" style="height: auto;">
            <Upload
              ref="IDImgList"
              :default-file-list="d_defaultList_ID"
              :action="$store.state.app.baseUrl + '/api/Pub/UploadFile?outType=contract&&type=合同附件'"
              multiple
              :headers="{Authorization:token}"
              :on-preview="img_preview"
              :on-format-error="file_format_error"
            >
              <Button icon="ios-cloud-upload-outline">请选择文件</Button>
            </Upload>
            <!--﻿ <p class="tip-p">允许上传的文件格式：txt，xlsx，doc。</p>-->
          </FormItem>
          <FormItem label="审批附件" prop="photos2" style="height: auto;">
            <Upload
              ref="businessImgList"
              :default-file-list="d_defaultList_business"
              :action="$store.state.app.baseUrl + '/api/Pub/UploadFile?outType=contract&&type=审批附件'"
              multiple
              :headers="{Authorization:token}"
              :on-format-error="file_format_error"
              :on-preview="img_preview"
            >
              <Button icon="ios-cloud-upload-outline">请选择文件</Button>
            </Upload>
            <!--﻿ <p class="tip-p">允许上传的格式：'jpg','jpeg','png','pdf','bmp'。</p>-->
          </FormItem>
          <FormItem label="签订日期" prop="SignDate">
            <DatePicker
              :value="add_params.SignDate"
              type="date"
              placeholder="请选择签订日期"
              @on-change="change_date_sign"
            ></DatePicker>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Modal title="图片预览" v-model="d_img_visible" @on-cancel="cancel_preview" footer-hide>
      <img :src="d_img_name" v-if="d_img_visible" style="width: 100%" />
    </Modal>
    <div>
      <Button type="primary" @click="confirm_edit_info('formValidate')">保存</Button>
      <Button @click="to_back_list" style="margin-left: 8px">取消</Button>
    </div>
  </div>
</template>
<script>
import apiContract from "../../api/contract.js";
import apiUser from "../../api/user.js";
import apiShop from "../../api/shop.js";
import mixin from "@/components/common/mixin.js";
export default {
  name: "leaseAdd_page",
  mixins: [mixin],
  data() {
    return {
      token: "",
      history_params: {},
      add_params: {},
      user_params: {},
      shop_params: {},
      d_search_key_user: [
        {
          value: "c.ID",
          label: "租户编号",
        },
        {
          value: "c.Name",
          label: "租赁单位/人",
        },
        {
          value: "c.BusinessLicense",
          label: "营业执照",
        },
        {
          value: "c.IDNum",
          label: "身份证号",
        },
        {
          value: "c.TouchMan",
          label: "联系人",
        },
        {
          value: "c.Phone",
          label: "手机",
        },
      ],
      d_search_key_shop: [
        {
          value: "s.ID",
          label: "编号",
        },
        {
          value: "s.PropNum",
          label: "产权证号",
        },
        {
          value: "s.Name",
          label: "商铺地址",
        },
        {
          value: "p.Province",
          label: "省",
        },
        {
          value: "p.City",
          label: "市",
        },
        {
          value: "p.County",
          label: "区",
        },
        {
          value: "p.Address",
          label: "详细地址",
        },
      ],
      d_edit_type: [], // 判断是新增状态还是编辑状态,默认为add
      ruleValidate: {
        Name: [
          { required: true, message: "合同名称不能为空", trigger: "blur" },
        ],
        Agent: [{ required: true, message: "经办人为必填项", trigger: "blur" }],
        //          Notes: [
        //            { required: true, message: '备注为必填项', trigger: 'blur' }
        //          ],
        SignDate: [
          { required: true, message: "签订日期必须选择", trigger: "blur" },
        ],
      },
      d_modal_user: false, // 选择承租人
      d_columns_user: [
        {
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "租赁单位/人",
          key: "Name",
        },
        {
          title: "身份证号",
          key: "IDNum",
        },
        {
          title: "营业执照",
          key: "BusinessLicense",
        },
      ],
      d_data_user: [],
      d_modal_shop: false, // 选择租用商铺
      d_columns_shop: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "编号",
          key: "ID",
        },
        {
          title: "商铺地址",
          key: "Name",
        },
        {
          title: "租赁合同面积m²",
          key: "Area",
        },
      ],
      d_data_shop: [],
      d_curr_shopList: [],
      d_currentRow: [],
      d_payType: "三个月",
      d_payType_list: [
        {
          value: "一个月",
          label: "月付(一个月)",
        },
        {
          value: "三个月",
          label: "季付(三个月)",
        },
        {
          value: "六个月",
          label: "半年付(六个月)",
        },
        {
          value: "十二个月",
          label: "年付(十二个月)",
        },
      ],
      d_defaultList_ID: [],
      d_defaultList_business: [],
      d_img_visible: false,
      d_img_name: "",
    };
  },
  methods: {
    storageInfo() {
      let infor = setInterval(() => {
        sessionStorage.setItem("leaseInfo", JSON.stringify(this.add_params));
      }, 600000);
    },
    changeArea() {
      this.add_params.AreaRent = this.add_params.Area;
    },
    to_openUser() {
      this.d_modal_user = true;
    },
    search_user() {
      this.user_params.PageIndex = 1;
      this.pull_data_user();
    },
    search_shop() {
      sessionStorage.setItem(
        "curr_shopList",
        JSON.stringify(this.d_curr_shopList)
      );
      this.shop_params.PageIndex = 1;
      this.pull_data_shop();
    },
    change_condList_user(value) {
      if (value === "c.ID") {
        this.user_params.CondList[0].Operator = "=";
      } else {
        this.user_params.CondList[0].Operator = "like";
      }
    },
    change_condList_shop(value) {
      if (
        value === "s.PropNum" ||
        value === "s.Name" ||
        value === "p.Address" ||
        value === "c.ID"
      ) {
        this.shop_params.CondList[0].Operator = "like";
      } else {
        this.shop_params.CondList[0].Operator = "=";
      }
    },
    pull_data_user() {
      let _this = this;
      apiUser.getList.post(this.user_params).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          let requestResult = _data.data.Data;
          _this.d_data_user = requestResult.RowsList;
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    change_user(currentRow) {
      this.d_modal_user = false;
      this.add_params.BPartyName = currentRow.Name;
      this.add_params.BPartyNum =
        currentRow.BusinessLicense || currentRow.IDNum; // 有营业执照就放u营业执照，没有几放身份证
      this.add_params.CusID = currentRow.ID;
    },
    other_modify(index) {
      switch (index) {
        case 1:
          return "一";
          break;
        case 2:
          return "二";
          break;
        case 3:
          return "三";
          break;
        case 4:
          return "四";
          break;
        case 5:
          return "五";
          break;
        case 6:
          return "六";
          break;
        case 7:
          return "七";
          break;
        case 8:
          return "八";
          break;
        case 9:
          return "九";
          break;
        case 10:
          return "十";
          break;
        default:
          return index;
          break;
      }
    },
    to_back_list() {
      this.$router.go(-1);
    },
    switch_payType(type) {
      switch (type) {
        case "一个月":
          return "月付";
          break;
        case "三个月":
          return "季付";
          break;
        case "六个月":
          return "半年付";
          break;
        case "十二个月":
          return "年付";
          break;
        default:
          return "季付";
          break;
      }
    },
    switch_payType2(type) {
      switch (type) {
        case "月付":
          return "一个月";
          break;
        case "季付":
          return "三个月";
          break;
        case "半年付":
          return "六个月";
          break;
        case "年付":
          return "十二个月";
          break;
        default:
          return "三个月";
          break;
      }
    },
    pull_data_edit() {
      let currId = this.d_edit_type[1];
      apiContract.getEditdto(currId).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          this.add_params = _data.data.Data;
          this.history_params = JSON.parse(JSON.stringify(_data.data.Data));
          this.d_payType = this.switch_payType2(this.add_params.CycleType);
          let fileList = this.add_params.FileList;
          let defaultListID = [];
          let defaultListBusiness = [];
          for (let i = 0; i < fileList.length; i++) {
            let thisFile = {};
            thisFile.name = fileList[i].Name || fileList[i].SaveName;
            thisFile.url = fileList[i].SaveName;
            if (fileList[i].Type === "合同附件") {
              defaultListID.push(thisFile);
            } else if (fileList[i].Type === "审批附件") {
              defaultListBusiness.push(thisFile);
            }
          }
          this.d_defaultList_ID = defaultListID;
          this.d_defaultList_business = defaultListBusiness;
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    pull_data_shop() {
      let _this = this;
      apiShop.getList.post(this.shop_params).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          let requestResult = _data.data.Data.RowsList;
          if (this.d_curr_shopList.length > 0) {
            let selectedShopListID = this.d_curr_shopList.map(
              (item) => item.ID
            );
            for (let item of requestResult) {
              if (selectedShopListID.indexOf(item.ID) > -1) {
                item._disabled = true;
              }
            }
          }
          _this.d_data_shop = requestResult;
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    shops_confirm() {
      this.d_modal_shop = false;
      sessionStorage.setItem("curr_shopList", "");
      let shopList = this.d_curr_shopList; // d_curr_shopList 存储已选择的商铺
      let addressStr = "";
      let areaNum = 0;
      let arrayData = "";
      for (let i = 0; i < shopList.length; i++) {
        arrayData += shopList[i].ID + ",";
        addressStr += shopList[i].Name + "、";
        areaNum += Number.parseFloat(shopList[i].Area);
      }
      arrayData =
        arrayData.substring(arrayData.length - 1) === ","
          ? arrayData.substring(0, arrayData.length - 1)
          : arrayData;
      addressStr =
        addressStr.substring(addressStr.length - 1) === "、"
          ? addressStr.substring(0, addressStr.length - 1)
          : addressStr;
      this.add_params.ShopIDs = arrayData;
      this.add_params.Address = addressStr; // 默认赋值地址
      this.add_params.Area = areaNum; // 默认赋值面积
    },
    to_openShop() {
      this.d_modal_shop = true;
      sessionStorage.setItem("curr_shopList", "");
    },
    change_shop(row) {
      let curr_shopList = sessionStorage.getItem("curr_shopList");
      if (curr_shopList) {
        curr_shopList = JSON.parse(curr_shopList);
        this.d_curr_shopList = row.concat(curr_shopList);
      } else {
        this.d_curr_shopList = row;
      }
    },
    change_date_start(date) {
      let startDate = (this.add_params.BeginDate = date);
      let endDate = this.add_params.EndDate;
      if (startDate != "" && endDate != "") {
        this.computedTime(startDate, endDate);
      }
    },
    change_date_end(date) {
      let startDate = this.add_params.BeginDate;
      let endDate = (this.add_params.EndDate = date);
      if (startDate != "" && endDate != "") {
        this.computedTime(startDate, endDate);
      }
    },
    change_date_sign(date) {
      this.add_params.SignDate = date;
    },
    computedTime(begin, end) {
      //计算时间
      let moment = require("moment");
      let beginDate = moment(begin);
      let endDate = moment(end);
      let yearsFloat = endDate.diff(beginDate, "years", true); // 期间多少年，小数
      let yearsInt = endDate.diff(beginDate, "years"); // 期间多少年，整数
      let TimeUnitFloat = Number.parseFloat(yearsFloat) * 12;
      let TimeUnitInt = Number.parseInt(TimeUnitFloat);
      if (TimeUnitFloat > TimeUnitInt) {
        this.add_params.TimeUnit = TimeUnitInt + 1;
      } else {
        this.add_params.TimeUnit = TimeUnitInt;
      }
      let timeStringBegin = moment(begin).unix();
      let timeStringEnd = moment(end).unix(); // 获取时间戳
      if (timeStringEnd > timeStringBegin) {
        let recordBegin = beginDate.format("YYYY-MM-DD");
        let PriceDetailList = [];
        for (let i = 0; i < yearsInt; i++) {
          let thisTimeString = timeStringBegin + (i + 1) * 31536000; //一年以365天来算
          let thisTimeEnd = moment.unix(thisTimeString).format("YYYY-MM-DD");
          let list = {};
          let detailList = JSON.parse(JSON.stringify(apiContract.add.data))
            .PriceDetailList[0].DetailList;
          list.BeginDate = recordBegin;
          list.EndDate = thisTimeEnd;
          list.YearPercent = 0;
          list.DetailList = detailList;
          recordBegin = moment
            .unix(thisTimeString + 86400)
            .format("YYYY-MM-DD"); //以后每次叠加从后一天开始
          PriceDetailList.push(list);
        }
        if (yearsFloat > yearsInt) {
          let list = {};
          list.BeginDate = recordBegin;
          list.EndDate = endDate.format("YYYY-MM-DD");
          list.YearPercent = 0;
          let detailList = JSON.parse(JSON.stringify(apiContract.add.data))
            .PriceDetailList[0].DetailList;
          list.DetailList = detailList;
          PriceDetailList.push(list);
        }
        this.add_params.PriceDetailList = PriceDetailList;
        console.log(this.add_params.PriceDetailList);
      } else {
        this.$Message.error("请正确选择开始时间和结束时间！");
      }
    },
    DX(n) {
      // 数字大写
      if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "数据非法";
      let unit = "千百拾亿千百拾万千百拾元角分",
        str = "";
      n += "00";
      let p = n.indexOf(".");
      if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
      unit = unit.substr(unit.length - n.length);
      for (let i = 0; i < n.length; i++)
        str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
      return str
        .replace(/零(仟|佰|拾|角)/g, "零")
        .replace(/(零)+/g, "零")
        .replace(/零(万|亿|元)/g, "$1")
        .replace(/(亿)万|壹(拾)/g, "$1$2")
        .replace(/^元零?|零分/g, "")
        .replace(/元$/g, "元整");
    },
    to_addPriceList() {
      //增加年度递增表
      let PriceDetailList = this.add_params.PriceDetailList;
      let list = JSON.parse(JSON.stringify(apiContract.add.data))
        .PriceDetailList[0];
      PriceDetailList.push(list);
    },
    to_delPriceList(_index) {
      let PriceDetailList = this.add_params.PriceDetailList;
      PriceDetailList.splice(_index, 1);
    },
    computedMeterPrice(index) {
      // 点击--递增年限的时候触发百分比来触发
      let PriceDetailList = this.add_params.PriceDetailList;
      let YearPercent = PriceDetailList[index].YearPercent;
      if (Number.parseFloat(YearPercent) > 0) {
        let prevDetailList = PriceDetailList[index - 1].DetailList; //index==0的时候没有进入此方法的事件
        // let MeterPricePrev = 0;
        // for(let i=0;i<prevDetailList.length;i++){
        //   if(prevDetailList[i].Type === '商铺租金'){
        //     MeterPricePrev = prevDetailList[i].MeterPrice;
        //   }
        // }
        let currDetailList = PriceDetailList[index].DetailList;
        for (let i = 0; i < currDetailList.length; i++) {
          let formatP =
            Number.parseFloat(prevDetailList[i].MeterPrice) *
            (1 + Number.parseFloat(YearPercent) / 100);
          currDetailList[i].MeterPrice = Number.parseFloat(formatP.toFixed(2));
          this.computedMonthPrice(index, i);
        }
      }
    },
    computedMeterPrice2(index, cindex) {
      //点击每月租金费用触发
      let PriceDetailList = this.add_params.PriceDetailList;
      let currDetailList = PriceDetailList[index].DetailList;
      let currAreaRent = Number.parseFloat(this.add_params.AreaRent);
      let MonthPrice = Number(currDetailList[cindex].MonthPrice);
      if (currAreaRent > 0) {
        currDetailList[cindex].MeterPrice = Number.parseFloat(
          (MonthPrice / currAreaRent).toFixed(2)
        );
        if (currDetailList[cindex].Type === "车位租金") {
          currDetailList[cindex].MeterPrice = MonthPrice;
        }
      }
    },
    computedMonthPrice(index, cindex) {
      let PriceDetailList = this.add_params.PriceDetailList;
      let currDetailList = PriceDetailList[index].DetailList;
      let currAreaRent = Number.parseFloat(this.add_params.AreaRent);
      let MeterPrice = Number(currDetailList[cindex].MeterPrice);
      if (currAreaRent > 0) {
        currDetailList[cindex].MonthPrice = MeterPrice * currAreaRent;
        if (currDetailList[cindex].Type === "车位租金") {
          currDetailList[cindex].MonthPrice = MeterPrice;
        }
      }
    },

    get_all_file() {
      this.add_params.FileList = [];
      let IDImgList = this.$refs.IDImgList.fileList;
      let businessImgList = this.$refs.businessImgList.fileList;
      let fileList = [];
      console.log(IDImgList, "这里面是什么");
      if (IDImgList.length > 0) {
        for (let i = 0; i < IDImgList.length; i++) {
          let currFile = {};
          currFile.OutType = "contract";
          currFile.Type = "合同附件";
          currFile.Name = IDImgList[i].name;
          if (IDImgList[i].response) {
            currFile.SaveName = IDImgList[i].response.Data;
          } else {
            currFile.SaveName = IDImgList[i].url;
          }
          fileList.push(currFile);
        }
      }
      if (businessImgList.length > 0) {
        for (let i = 0; i < businessImgList.length; i++) {
          let currFile = {};
          currFile.OutType = "contract";
          currFile.Type = "审批附件";
          if (businessImgList[i].response) {
            currFile.SaveName = businessImgList[i].response.Data;
          } else {
            currFile.SaveName = businessImgList[i].name;
          }
          fileList.push(currFile);
        }
      }
      this.add_params.FileList = fileList;
    },
    del_empty_list() {
      let PriceDetailList = this.add_params.PriceDetailList;
      for (let i = 0; i < PriceDetailList.length; i++) {
        if (
          PriceDetailList[i].BeginDate === "" ||
          PriceDetailList[i].BeginDate === ""
        ) {
          PriceDetailList.splice(i, 1);
          i--;
        } else {
          let DetailList = PriceDetailList[i].DetailList;
          for (let j = 0; j < DetailList.length; j++) {
            if (
              DetailList[j].MonthPrice === "" ||
              DetailList[j].MonthPrice === 0
            ) {
              DetailList.splice(j, 1);
              j--;
            }
          }
          PriceDetailList[i].DetailList = DetailList;
        }
      }
    },
    validate_other() {
      this.add_params.AreaRent = Number(this.add_params.AreaRent);
      this.add_params.Area = Number(this.add_params.Area);
      this.add_params.TimeUnit = Number(this.add_params.TimeUnit);
      this.add_params.FirstQuarterRent = Number(
        this.add_params.FirstQuarterRent
      );
      this.add_params.AgreeDeposit = Number(this.add_params.AgreeDeposit);
      this.add_params.WaterDeposit = Number(this.add_params.WaterDeposit);
      if (this.add_params.CusID === "" || this.add_params.BPartyNum === "") {
        this.$Message.error("请选择承租方!");
        return false;
      }
      if (this.add_params.ShopIDs === "") {
        this.$Message.error("请选择合同对应的商铺!");
        return false;
      }
      if (this.add_params.BusinessScope === "") {
        this.$Message.error("第二条，租赁用途以及经营范围你不能为空!");
        return false;
      }
      if (this.add_params.TimeUnit === 0) {
        this.$Message.error("第三条，租赁期限不能为空或格式不正确!");
        return false;
      }
      if (this.add_params.BeginDate === "") {
        this.$Message.error("第三条，租赁期限开始时间不能为空!");
        return false;
      }
      if (this.add_params.EndDate === "") {
        this.$Message.error("第三条，租赁期限结束时间不能为空!");
        return false;
      }
      if (this.add_params.AreaRent === 0) {
        this.$Message.error("第四条，租赁物建筑面积不能为空!");
        return false;
      }
      if (this.add_params.AgreeDeposit === 0) {
        this.$Message.error("第四条，第4点，履约押金为必填项!");
        return false;
      }
      //        if(this.add_params.WaterDeposit === 0){
      //          this.$Message.error('第四条，第4点，水电保证金为必填项!');
      //          return false;
      //        }
      if (this.add_params.FirstQuarterRent === 0) {
        this.$Message.error("第四条，第5点，每月租赁费用为必填项!");
        return false;
      }
      if (this.add_params.PriceDetailList.length < 1) {
        this.$Message.error("第四条，第1点，第(2)项，年度租赁费用至少有一条!");
        return false;
      } else {
        let PriceDetailList = this.add_params.PriceDetailList;
        if (PriceDetailList[0].DetailList.length < 1) {
          this.$Message.error(
            "第四条，第1点，第(2)项，年度租赁费用第一条中每月租金必填!"
          );
          return false;
        }
      }
      let IDImgList = this.$refs.IDImgList.fileList;
      let businessImgList = this.$refs.businessImgList.fileList;
      //        if(IDImgList.length<1){
      //          this.$Message.error('合同附件未上传!');
      //          return false;
      //        }
      //        if(businessImgList.length<1){
      //          this.$Message.error('审批附件未上传!');
      //          return false;
      //        }
      return true;
    },
    confirm_edit_info(name) {
      if (this.validate_other()) {
        this.add_params.CycleType = this.switch_payType(this.d_payType);

        this.get_all_file();
        this.del_empty_list();
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.submit_data();
          } else {
            this.$Message.error("验证失败!");
          }
        });
      }
    },
    to_date(date) {
      let moment = require("moment");
      return moment(date).format("YYYY-MM-DD");
    },
    exchangeParamsData(name) {
      switch (name) {
        case "Area":
          return "租赁物建筑面积";
          break;
        case "BusinessScope":
          return "乙方承租租赁物的用途及经营范围";
          break;
        case "AreaRent":
          return "租赁物建筑面积";
          break;
        case "AgreeDeposit":
          return "履约保证金";
          break;
        case "WaterDeposit":
          return "水电保证金";
          break;
        case "FirstQuarterRent":
          return this.d_payType + "的租赁费用";
          break;
        case "CycleType":
          return "交租方式";
          break;
        case "Name":
          return "合同名称";
          break;
        case "Agent":
          return "经办人";
          break;
        case "Notes":
          return "备注";
          break;
        case "SignDate":
          return "签订日期";
          break;
      }
    },
    saveEditData(_data) {
      //保存每一次的修改记录
      let today = this.to_date(new Date());
      let hData = this.history_params;
      let editData = [];
      let unableEdit = ["PriceDetailList", "JianyizhiList", "FileList"];
      for (let name in _data) {
        if (unableEdit.indexOf(name) <= -1) {
          if (hData[name] != _data[name]) {
            editData.push({
              ContractID: _data.SerialNum,
              ValueName: this.exchangeParamsData(name),
              BeforeValue: hData[name],
              AfterValue: _data[name],
              EditDate: today,
            });
          }
        }
      }
      for (let j = 0; j < _data.PriceDetailList.length; j++) {
        let item = _data.PriceDetailList[j];
        if (
          _data.PriceDetailList[j].YearPercent !=
          hData.PriceDetailList[j].YearPercent
        ) {
          editData.push({
            ContractID: hData.SerialNum,
            ValueName: "第" + (j + 1) + "个租赁年度每年递增百分比",
            BeforeValue: Number(hData.PriceDetailList[j].YearPercent),
            AfterValue: Number(_data.PriceDetailList[j].YearPercent),
            EditDate: today,
          });
        }
        for (let i = 0; i < item.DetailList.length; i++) {
          for (let keyName in item.DetailList[i]) {
            if (
              item.DetailList[i][keyName] !=
              hData.PriceDetailList[j].DetailList[i][keyName]
            ) {
              let ValueName = item.DetailList[i].Type;
              if (keyName === "MeterPrice") {
                ValueName = ValueName + "的每平米月租";
              }
              editData.push({
                ContractID: hData.SerialNum,
                ValueName: "第" + (j + 1) + "个租赁年度的" + ValueName,
                BeforeValue: Number(
                  hData.PriceDetailList[j].DetailList[i][keyName]
                ),
                AfterValue: Number(item.DetailList[i][keyName]),
                EditDate: today,
              });
            }
          }
        }
      }
      // 存储fileList的历史记录
      // for(let i=0;i<_data.FileList.length;i++){
      //   if(_data.FileList[i].SaveName!=hData.FileList[i].SaveName){
      //     editData.push({
      //       ContractID: hData.SerialNum,
      //       ValueName: _data.FileList[i].Type,
      //       BeforeValue: hData.FileList[i].SaveName,
      //       AfterValue: _data.FileList[i].SaveName,
      //       EditDate: today
      //     });
      //   }
      // }
      this.add_params.ContractHistoryList = editData;
    },
    submit_data() {
      let _this = this;
      if (_this.d_edit_type[0] === "add") {
        apiContract.add.post(this.add_params).then((_data) => {
          if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
            this.$Message.success("添加成功");
            this.$refs.IDImgList.clearFiles();
            this.$refs.businessImgList.clearFiles();
            this.to_back_list();
          } else {
            this.$Message.error({
              content: _data.data.Msg,
              duration: 10,
              closable: true,
            });
          }
        });
      } else if (_this.d_edit_type[0] === "edit") {
        this.saveEditData(this.add_params);
        apiContract.edit.post(this.add_params).then((_data) => {
          if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
            this.$Message.success("修改成功");
            this.$refs.IDImgList.clearFiles();
            this.$refs.businessImgList.clearFiles();
            this.to_back_list();
          } else {
            this.$Message.error(_data.data.Msg);
          }
        });
      } else if (_this.d_edit_type[0] === "prev") {
        this.add_params.PrevSerialNum = _this.d_edit_type[1];
        this.add_params.SerialNum = "";
        apiContract.add.post(this.add_params).then((_data) => {
          if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
            this.$Message.success("添加成功");
            this.$refs.IDImgList.clearFiles();
            this.$refs.businessImgList.clearFiles();
            this.to_back_list();
          } else {
            this.$Message.error(_data.data.Msg);
          }
        });
      }
    },
  },
  created() {
    this.add_params = JSON.parse(JSON.stringify(apiContract.add.data));
    this.user_params = JSON.parse(JSON.stringify(apiUser.getList.data));
    this.shop_params = JSON.parse(JSON.stringify(apiShop.getList.data));
    let params = this.$route.params.id; //id带的字符串
    this.d_edit_type = params.split("&"); //第一个参数id，第二个参数type(edit,add)
    let leaseInfo = sessionStorage.getItem("leaseInfo");
    if (leaseInfo && this.d_edit_type[0] === "add") {
      this.add_params = JSON.parse(leaseInfo);
    }
  },
  mounted() {
    this.token = sessionStorage.getItem("token");
    if (this.d_edit_type[0] === "edit" || this.d_edit_type[0] === "prev") {
      this.pull_data_edit();
    }
    this.user_params.PageIndex = 1;
    this.user_params.PageSize = 9999;
    this.shop_params.PageIndex = 1;
    this.shop_params.PageSize = 9999;
    this.pull_data_user();
    this.pull_data_shop();
    this.storageInfo(); //每10分钟存储一次
  },
};
</script>
<style>
.lease-page .ivu-input-wrapper {
  width: 100px;
  margin-left: 10px;
  margin-right: 10px;
}
.lease-page .ivu-date-picker .ivu-input-wrapper {
  width: auto;
}
</style>
<style lang="less" scoped>
@import "../../assets/css/table-list.css";
.lease-page {
  position: relative;
  box-sizing: border-box;
  padding: 20px;
  padding-right: 80px;
  width: 100%;
  min-height: 980px;
  background-color: #fff;
  font-size: 14px;
  p {
    line-height: 30px;
  }
  .page-number {
    padding: 20px;
    text-align: center;
  }
  h4 {
    clear: both;
    margin-top: 10px;
  }
  .user_info_group p {
    margin-bottom: 10px;
    line-height: 30px;
  }
}
.padding-l20 {
  padding-left: 20px;
}
.padding-l34 {
  padding-left: 34px;
}
.indent10 {
  text-indent: 20px;
}
.btn_add {
  position: absolute;
  right: 20px;
}
.btn_add_shop {
  margin-top: -10px;
}
.btn_del_shop {
  margin-top: 6px;
}
.type-group {
  .ivu-input-wrapper {
    width: 200px;
    margin-right: 10px;
  }
}
.h-width {
  display: inline-block;
  width: 200px;
}
i {
  font-style: normal;
}
</style>

